import { _breakP } from './utils.js';
export default class swipefigure {
  constructor() {
    this.figurePosition();
    this.scrollBarFunc();
  }

  figurePosition() {
    const $swipeFigure = document.querySelectorAll('.js-figPosition');
    if ($swipeFigure.length) {
      $swipeFigure.forEach(elm => {

        let once = false;

        const scrollCallback = function () {
          function scrollInt() {
            const halfValue = 2;
            const elmImage = elm.querySelector('.photo__image');
            const elmW = elmImage.clientWidth - elm.clientWidth;
            const elmHW = elmW / halfValue;
            let initPos = 0;
            if (elm.classList.contains('js-figPosition-center')) {
              initPos = elmHW;
            }
            if (elm.classList.contains('js-figPosition-right')) {
              initPos = elmW;
            }

            if (once === false) {
              elm.scrollLeft = initPos;
              once = true;
            }
          }

          if (elm.getBoundingClientRect().top <= window.innerHeight) {
            if (elm.dataset.mode === 'sp') {
              _breakP.SP ? scrollInt() : null;
            } else if (elm.dataset.mode === 'pc') {
              !_breakP.SP ? scrollInt() : null;
            } else {
              scrollInt();
            }
          }
        };

        window.addEventListener('scroll', scrollCallback);

      });
    }
  }

  scrollBarFunc() {
    const $scrollBar = document.querySelectorAll('.js-scrollBar');
    if ($scrollBar.length) {

      $scrollBar.forEach((elm, index) => {
        const $currentBar = elm.children[0];

        const $target = Array.from(elm.parentElement.querySelectorAll('*')).filter(elm => {
          const style = window.getComputedStyle(elm);
          return (
            (style.overflowX === 'scroll' || style.overflowX === 'auto') &&
            elm.scrollWidth > elm.clientWidth
          );
        });

        if (!$target.length) return;

        const barFunc = () => {
          const updateScrollBar = () => {

            const maxScrollLeft = $target[0].scrollWidth - $target[0].clientWidth;
            const visibleRatio = $target[0].clientWidth / $target[0].scrollWidth;
            $currentBar.style.width = `${visibleRatio * 100}%`;
            const scrollPercentage = $target[0].scrollLeft / maxScrollLeft;
            const maxLineMove = elm.clientWidth - $currentBar.clientWidth;
            const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
            const remValue = (scrollPercentage * maxLineMove) / rootFontSize;
            $currentBar.style.transform = `translateX(${remValue}rem)`;
          };

          $target[0].addEventListener('scroll', updateScrollBar);
          updateScrollBar();
        }

        if ($target[0].dataset.mode === 'pc') {
          if (!_breakP.SP) barFunc();
        } else if ($target[0].dataset.mode === 'sp') {
          if (_breakP.SP) barFunc();
        } else {
          barFunc();
        }
      });
    }
  }
}
